import axios from 'axios';
import globals from './globals'

export default {
    getDemand() {
        const token = localStorage.getItem("token");

        const header = {
            'Content-Type' : 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`,
            /*'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',*/
        }

        return axios.get(globals.HOST_NAME + "/api/v1/demand", {
            headers: header
        });
    },
    getDemandDetail(id) {
        const token = localStorage.getItem("token");

        const header = {
            'Content-Type' : 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`,
            /*'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',*/
        }

        return axios.get(globals.HOST_NAME + "/api/v1/demand/" + id, {
            headers: header
        });
    },
    insertDemandEntry(data) {
        const token = localStorage.getItem("token");

        const header = {
            'Content-Type' : 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
            /*'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',*/
        }

        return axios.post(globals.HOST_NAME + "/api/v1/demand/", data, {
            headers: header
        });
    },
    updateDemandEntry(data) {
        const token = localStorage.getItem("token");

        const header = {
            'Content-Type' : 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
            /*'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',*/
        }

        return axios.put(globals.HOST_NAME + "/api/v1/demand/", data, {
            headers: header
        });
    },
    deleteDemandEntry(id) {
        const token = localStorage.getItem('token');
        const header = {
            //'Content-Type' : 'application/json',
            'Content-Type' : 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
            /*'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',*/
        }

        return axios.delete(globals.HOST_NAME + "/api/v1/demand/" + id, {
            headers: header
        });
    },
    setDemandLike(data) {
        const token = localStorage.getItem('token');
        const header = {
            'Content-Type' : 'application/json',
            'Authorization': `Bearer ${token}`,
            /*'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',*/
        }

        return axios.post(globals.HOST_NAME + "/api/v1/voting/", data, {
            headers: header
        });
    },
    getDemandLikes(id) {
        const token = localStorage.getItem("token");

        const header = {
            'Content-Type' : 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${token}`,
            /*'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',*/
        }

        return axios.get(globals.HOST_NAME + "/api/v1/voting/" + id, {
            headers: header
        });
    }
}